import tanamasf21 from "./tanamasf2 (1).webp";
import tanamasf22 from "./tanamasf2 (2).webp";
import tanamasf23 from "./tanamasf2 (3).webp";
import tanamasf24 from "./tanamasf2 (4).webp";
import tanamasf25 from "./tanamasf2 (5).webp";
import tanamasf26 from "./tanamasf2 (6).webp";

const tanamasF2 = [
  tanamasf21,
  tanamasf22,
  tanamasf23,
  tanamasf24,
  tanamasf25,
  tanamasf26,
];
export default tanamasF2;
